import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from '@/helpers/classNames'
import RichTextEditor from '@/ui/RTE/Medium'
import InlineEdit from '@/ui/Input/Content'
import {
  RTE as RteText,
  HEADER as HeaderText,
  BUTTON as ButtonText,
  NOITEMS as NoAkademieItems,
} from '@/state/types/defaultLabel'

class AkademieBlock extends Component {
  static displayName = 'Card / Akademie'
  static propTypes = {
    item: PropTypes.object.isRequired,
  }

  render() {
    const { item, active, onChange, theme } = this.props

    return (
      <div className={classNames(theme, 'renderpreview', 'akademie-preview')}>
        <Choose>
          <When condition={item.data && item.data.length}>
            <For each="element" index="indx" of={item.data}>
              <div key={indx}>
                <InlineEdit
                  tagName="h4"
                  html={element.header || HeaderText}
                  textual
                  selectText={HeaderText}
                  onChange={(e, value) => onChange(item, [indx, 'header'], value)}
                />
                <Choose>
                  <When condition={active}>
                    <RichTextEditor
                      id="text"
                      name="text"
                      key={`rte${item.id}`}
                      value={element.text || RteText}
                      selectText={RteText}
                      onChange={value => onChange(item, [indx, 'text'], value)}
                    />
                  </When>
                  <Otherwise>
                    <div dangerouslySetInnerHTML={{ __html: element.text || RteText }} />
                  </Otherwise>
                </Choose>

                <button
                  className={classNames(theme, 'button', 'button-outline')}
                  style={{ marginTop: '24px', padding: '16px' }}
                >
                  {element.buttontext || ButtonText}
                </button>
              </div>
            </For>
          </When>
          <Otherwise>
            <p className={theme['no-items']}>{NoAkademieItems}</p>
          </Otherwise>
        </Choose>
      </div>
    )
  }
}

export default AkademieBlock



// WEBPACK FOOTER //
// ./ui/Blocks/Akademie.js